// src/pages/Dashboard.jsx
// ── Header + CAS pills REMOVED — GlobalHeader handles them globally ──────────

import { useStaticKpi } from "../hooks/useStaticKpi";
import KpiEditModal from "../components/KpiEditModal";
import "./dashboard.css";
import { useState, useEffect, useRef } from "react";
import { useGlobalFilter } from "../components/GlobalHeader"; // ← ADD THIS
import {
  getManufacturerDetailsAPI,
  getDeviceDetails,
  getOverallWarehouseStock,
  getOverallUserCount,
  branch_id,
  getAllStatus,
  getAllDistributor,
  getLcoList,
  getAllLcoList,
  getAllCities,
  getDaywiseStatus,
} from "../api/api";

// ─── Animated Count-Up Number ──────────────────────────────────────────────
function AnimatedNumber({ value, loading }) {
  const [display, setDisplay] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (loading || value === null || value === undefined) return;
    if (typeof value === "object") return;
    const raw =
      typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
    if (isNaN(raw)) { setDisplay(value); return; }
    const safeRaw = Math.max(0, raw);
    const duration = 900;
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setDisplay(Math.floor(safeRaw * eased));
      if (progress < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, loading]);

  if (loading)
    return (
      <span style={{ opacity: 0.4, animation: "loadingPulse 1.2s ease-in-out infinite" }}>
        ...
      </span>
    );
  if (value === null || value === undefined) return <span>N/A</span>;
  if (typeof value === "object") return <span>N/A</span>;
  const raw =
    typeof value === "string" ? parseFloat(value.replace(/,/g, "")) : value;
  if (isNaN(raw)) return <span>{value}</span>;
  return <span>{Math.max(0, display).toLocaleString("en-IN")}</span>;
}

// ─── Searchable Select ────────────────────────────────────────────────────
function SearchableSelect({ value, onChange, options, placeholder, disabled }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered =
    search.trim() === ""
      ? options
      : options.filter((o) => o.label.toLowerCase().includes(search.toLowerCase()));
  const selectedLabel = options.find((o) => String(o.value) === String(value))?.label;

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div
        onClick={() => { if (!disabled) { setOpen((o) => !o); setSearch(""); } }}
        style={{
          padding: "9px 11px",
          border: `1px solid ${open ? "#6366f1" : "#e5e7eb"}`,
          borderRadius: "8px", fontSize: "13px",
          color: value ? "#1f2937" : "#9ca3af",
          background: disabled ? "#f9fafb" : "white",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          boxShadow: open ? "0 0 0 3px rgba(99,102,241,0.12)" : "none",
          transition: "all 0.2s ease", userSelect: "none",
        }}
      >
        <span>{selectedLabel || placeholder}</span>
        <span style={{
          borderLeft: "5px solid transparent", borderRight: "5px solid transparent",
          borderTop: "6px solid #9ca3af", display: "inline-block",
          transition: "transform 0.2s ease",
          transform: open ? "rotate(180deg)" : "rotate(0deg)",
          marginLeft: "8px", flexShrink: 0,
        }} />
      </div>
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0,
          background: "white", border: "1px solid #e5e7eb", borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)", zIndex: 999999,
        }}>
          <div style={{ padding: "6px 8px", background: "white" }}>
            <input
              autoFocus value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              style={{
                width: "100%", padding: "7px 10px", border: "1.5px solid #c7d2fe",
                borderRadius: "6px", fontSize: "13px", outline: "none",
                fontFamily: "inherit", background: "#fafafa", color: "#1f2937",
                boxSizing: "border-box",
              }}
            />
          </div>
          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            <div
              onClick={() => { onChange(""); setOpen(false); setSearch(""); }}
              style={{
                padding: "10px 14px", fontSize: "13px", cursor: "pointer",
                background: value === "" ? "#eef2ff" : "white", color: "#1f2937",
                fontWeight: value === "" ? 600 : 400,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#eef2ff")}
              onMouseLeave={(e) => (e.currentTarget.style.background = value === "" ? "#eef2ff" : "white")}
            >
              {placeholder}
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding: "10px 14px", fontSize: "12px", color: "#9ca3af", textAlign: "center" }}>
                No results found
              </div>
            ) : (
              filtered.map((o) => (
                <div
                  key={o.value}
                  onClick={() => { onChange(o.value); setOpen(false); setSearch(""); }}
                  style={{
                    padding: "10px 14px", fontSize: "13px", cursor: "pointer",
                    background: String(value) === String(o.value) ? "#eef2ff" : "white",
                    color: "#1f2937",
                    fontWeight: String(value) === String(o.value) ? 600 : 400,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#eef2ff")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = String(value) === String(o.value) ? "#eef2ff" : "white")}
                >
                  {o.label}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Dashboard ─────────────────────────────────────────────────────────────
export default function Dashboard() {
  const [tab, setTab] = useState("today");
  const { overrides, saveOverride, loading: kpiLoading } = useStaticKpi();
  const [editingField, setEditingField] = useState(null);
  const isTestUser = localStorage.getItem("username") === "stockadmin";

  // ── READ CAS FROM GLOBAL HEADER ─────────────────────────────────────────
  const { cas } = useGlobalFilter(); // ← replaces selectedCas state entirely

  const PencilBtn = ({ fieldKey, label }) => {
    if (!isTestUser) return null;
    return (
      <button
        title={`Edit ${label}`}
        onClick={() => setEditingField({ key: fieldKey, label, value: overrides[fieldKey] })}
        style={{
          position: "absolute", top: 8, right: 8, background: "none",
          border: "none", cursor: "pointer", opacity: 0.4, fontSize: 14,
          padding: 4, transition: "opacity 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.4)}
      >
        ✏️
      </button>
    );
  };

  // ─── Local Filter State (distributor/lco/city stay here) ──────────────
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [selectedLco, setSelectedLco] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [appliedFilters, setAppliedFilters] = useState({
    distributor_id: "",
    operator_id: "",
    city_id: "",
  });

  // ─── Dropdown Lists ───────────────────────────────────────────────────
  const [distributorList, setDistributorList] = useState([]);
  const [loadingDistributorList, setLoadingDistributorList] = useState(true);
  const [allLcoList, setAllLcoList] = useState([]);
  const [loadingAllLco, setLoadingAllLco] = useState(true);
  const [lcoList, setLcoList] = useState([]);
  const [loadingLco, setLoadingLco] = useState(false);
  const [citiesList, setCitiesList] = useState([]);
  const [loadingCitiesList, setLoadingCitiesList] = useState(true);

  // ─── Data State ──────────────────────────────────────────────────────
  const [manufacturerData, setManufacturerData] = useState(null);
  const [loadingManufacturer, setLoadingManufacturer] = useState(true);
  const [manufacturerError, setManufacturerError] = useState("");

  const [deviceData, setDeviceData] = useState(null);
  const [loadingDevice, setLoadingDevice] = useState(true);
  const [deviceError, setDeviceError] = useState("");

  const [warehouseData, setWarehouseData] = useState(null);
  const [loadingWarehouse, setLoadingWarehouse] = useState(true);
  const [warehouseError, setWarehouseError] = useState("");

  const [distributorWarehouseData, setDistributorWarehouseData] = useState(null);
  const [loadingDistributorWarehouse, setLoadingDistributorWarehouse] = useState(true);

  const [lcoWarehouseData, setLcoWarehouseData] = useState(null);
  const [loadingLcoWarehouse, setLoadingLcoWarehouse] = useState(true);

  const [userCount, setUserCount] = useState(null);
  const [loadingUserCount, setLoadingUserCount] = useState(true);
  const [userCountError, setUserCountError] = useState("");

  const [userStatus, setUserStatus] = useState(null);
  const [loadingUserStatus, setLoadingUserStatus] = useState(true);

  const [activityData, setActivityData] = useState({ today: null, weekly: null, monthly: null });
  const [loadingActivity, setLoadingActivity] = useState(true);
  const [activityError, setActivityError] = useState("");

  // ─── Auto-apply local filters ─────────────────────────────────────────
  useEffect(() => {
    setAppliedFilters({
      distributor_id: selectedDistributor,
      operator_id: selectedLco,
      city_id: selectedCity,
    });
  }, [selectedDistributor, selectedLco, selectedCity]);

  // ─── Fetch Dropdowns ──────────────────────────────────────────────────
  useEffect(() => {
    getAllDistributor().then((r) => setDistributorList(r.data || [])).finally(() => setLoadingDistributorList(false));
    getAllLcoList().then((r) => setAllLcoList(r.data || [])).finally(() => setLoadingAllLco(false));
    getAllCities().then((r) => setCitiesList(r.data || [])).finally(() => setLoadingCitiesList(false));
  }, []);

  // ─── Fetch Data — triggers on CAS (global) OR local filter change ──────
  useEffect(() => {
    const { distributor_id, operator_id, city_id } = appliedFilters;

    const fetchManufacturerDetails = async () => {
      try {
        setLoadingManufacturer(true); setManufacturerError("");
        const r = await getManufacturerDetailsAPI();
        setManufacturerData(r.data);
      } catch { setManufacturerError("Failed to load manufacturer data."); }
      finally { setLoadingManufacturer(false); }
    };

    const fetchDeviceDetails = async () => {
      try {
        setLoadingDevice(true); setDeviceError("");
        const r = await getDeviceDetails();
        setDeviceData(r.data);
      } catch { setDeviceError("Failed to load device data."); }
      finally { setLoadingDevice(false); }
    };

    const fetchOverallUserCount = async () => {
      try {
        setLoadingUserCount(true); setUserCountError("");
        const [distRes, lcoRes] = await Promise.all([
          getOverallUserCount(2, city_id, distributor_id, operator_id, cas),
          getOverallUserCount(3, city_id, distributor_id, operator_id, cas),
        ]);
        setUserCount({ distributorCount: distRes.data, lcoCount: lcoRes.data });
      } catch { setUserCountError("Failed to load user count data."); }
      finally { setLoadingUserCount(false); }
    };

    const fetchOverallUserStatus = async () => {
      try {
        setLoadingUserStatus(true);
        const [activeRes, inactiveRes] = await Promise.all([
          getAllStatus("active", city_id, distributor_id, operator_id, cas),
          getAllStatus("inactive", city_id, distributor_id, operator_id, cas),
        ]);
        setUserStatus({ activeCount: activeRes.data.status, inactiveCount: inactiveRes.data.status });
      } catch { console.error("Failed to load user status."); }
      finally { setLoadingUserStatus(false); }
    };

    const fetchActivityDetails = async () => {
      try {
        setLoadingActivity(true); setActivityError("");
        const [todayRes, weeklyRes, monthlyRes] = await Promise.all([
          getDaywiseStatus("TODAY", city_id, distributor_id, operator_id, cas),
          getDaywiseStatus("WEEKLY", city_id, distributor_id, operator_id, cas),
          getDaywiseStatus("MONTHLY", city_id, distributor_id, operator_id, cas),
        ]);
        setActivityData({ today: todayRes.data, weekly: weeklyRes.data, monthly: monthlyRes.data });
      } catch { setActivityError("Failed to load activity data."); }
      finally { setLoadingActivity(false); }
    };

    fetchManufacturerDetails();
    fetchDeviceDetails();
    fetchOverallUserCount();
    fetchOverallUserStatus();
    fetchActivityDetails();
  }, [cas, appliedFilters]); // ← cas from global, appliedFilters from local

  // ─── Fetch Warehouse ──────────────────────────────────────────────────
  useEffect(() => {
    const { distributor_id, operator_id, city_id } = appliedFilters;
    const fetchWarehouseDetails = async () => {
      try {
        setLoadingWarehouse(true); setLoadingDistributorWarehouse(true); setLoadingLcoWarehouse(true);
        setWarehouseError("");
        const [roRes, distributorRes, lcoRes] = await Promise.all([
          getOverallWarehouseStock(branch_id, "", city_id, distributor_id, operator_id, cas),
          getOverallWarehouseStock(branch_id, 2, city_id, distributor_id, operator_id, cas),
          getOverallWarehouseStock(branch_id, 3, city_id, distributor_id, operator_id, cas),
        ]);
        setWarehouseData(roRes.data);
        setDistributorWarehouseData(distributorRes.data);
        setLcoWarehouseData(lcoRes.data);
      } catch { setWarehouseError("Failed to load warehouse data."); }
      finally { setLoadingWarehouse(false); setLoadingDistributorWarehouse(false); setLoadingLcoWarehouse(false); }
    };
    fetchWarehouseDetails();
  }, [cas, appliedFilters]); // ← cas from global, appliedFilters from local

  // ─── Filtered LCO list when distributor selected ──────────────────────
  useEffect(() => {
    if (!selectedDistributor) { setLcoList([]); setSelectedLco(""); return; }
    setLoadingLco(true);
    getLcoList(selectedDistributor).then((r) => setLcoList(r.data || [])).finally(() => setLoadingLco(false));
  }, [selectedDistributor]);

  // ─── Reset ────────────────────────────────────────────────────────────
  const handleResetFilters = () => {
    setSelectedDistributor("");
    setSelectedLco("");
    setSelectedCity("");
    setLcoList([]);
  };

  const activeLcoOptions = (selectedDistributor ? lcoList : allLcoList).map(
    (l) => ({ value: String(l.id), label: l.name })
  );
  const lcoDropdownLoading = selectedDistributor ? loadingLco : loadingAllLco;

  return (
    <div className="container">

      {/* ── Advanced Search (Distributor / LCO / City only) ──────────── */}
      <div className="filter-section">
        <h3 className="filter-title"><span>🔍</span> Advanced Search</h3>
        <div style={{ borderTop: "1px solid #f1f5f9", marginBottom: "16px" }} />
        <div className="filter-grid">
          <div className="filter-group">
            <label className="filter-label">Distributor</label>
            <SearchableSelect
              value={selectedDistributor}
              onChange={(val) => { setSelectedDistributor(val); setSelectedLco(""); }}
              options={distributorList.map((d) => ({ value: String(d.id), label: d.name }))}
              placeholder={loadingDistributorList ? "Loading..." : "All Distributors"}
              disabled={loadingDistributorList}
            />
          </div>
          <div className="filter-group">
            <label className="filter-label">LCO</label>
            <SearchableSelect
              value={selectedLco}
              onChange={setSelectedLco}
              options={activeLcoOptions}
              placeholder={lcoDropdownLoading ? "Loading..." : "All LCOs"}
              disabled={lcoDropdownLoading}
            />
          </div>
          <div className="filter-group">
            <label className="filter-label">City</label>
            <SearchableSelect
              value={selectedCity}
              onChange={setSelectedCity}
              options={citiesList.map((c) => ({ value: String(c.id), label: c.name }))}
              placeholder={loadingCitiesList ? "Loading..." : "All Cities"}

              disabled={loadingCitiesList}
         
         />
          </div>
          <div className="filter-button-group">
            <button className="filter-btn filter-btn-reset" onClick={handleResetFilters}>
              Reset
            </button>
          </div>
        </div>
      </div>

      {/* ── Manufacturer Details ─────────────────────────────────────── */}
      <div className="section-heading"><h2>🏭 Manufacturer Details</h2></div>
      {manufacturerError && (
        <div style={{ background: "#fee2e2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", color: "#7f1d1d", fontSize: "14px" }}>
          ⚠️ {manufacturerError}
        </div>
      )}
      <div className="kpi-grid">
        <div className="kpi-card" style={{ position: "relative" }}>
          <PencilBtn fieldKey="po_release" label="PO Release" />
          <div className="kpi-label">PO Release</div>
          <div className="kpi-value"><AnimatedNumber value={overrides.po_release} loading={kpiLoading} /></div>
        </div>
        <div className="kpi-card" style={{ position: "relative" }}>
          <PencilBtn fieldKey="inproduction" label="In Production" />
          <div className="kpi-label">In Production</div>
          <div className="kpi-value"><AnimatedNumber value={overrides.inproduction} loading={kpiLoading} /></div>
        </div>
        <div className="kpi-card" style={{ position: "relative" }}>
          <PencilBtn fieldKey="warehouse" label="Move To Warehouse" />
          <div className="kpi-label">Move To Warehouse</div>
          <div className="kpi-value"><AnimatedNumber value={overrides.warehouse} loading={kpiLoading} /></div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">DM Stock</div>
          <div className="kpi-value"><AnimatedNumber value={warehouseData?.alloted} loading={loadingWarehouse} /></div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Unassigned Stock</div>
          <div className="kpi-value"><AnimatedNumber value={warehouseData?.instock} loading={loadingWarehouse} /></div>
        </div>
        <div className="kpi-card">
          <div className="kpi-label">Fault Stock</div>
          <div className="kpi-value"><AnimatedNumber value={warehouseData?.faulty} loading={loadingWarehouse} /></div>
        </div>
      </div>

      {editingField && (
        <KpiEditModal
          label={editingField.label} fieldKey={editingField.key}
          currentValue={editingField.value} onSave={saveOverride}
          onClose={() => setEditingField(null)}
        />
      )}

      {/* ── Overall Details ──────────────────────────────────────────── */}
      <div className="section-heading"><h2>📈 Overall Details</h2></div>
      {warehouseError && (
        <div style={{ background: "#fee2e2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", color: "#7f1d1d", fontSize: "14px" }}>
          ⚠️ {warehouseError}
        </div>
      )}
      <div className="overall-grid">
        <div className="overall-card warehouse">
          <div className="card-title">Warehouse Stocks</div>
          <div className="card-number"><AnimatedNumber value={warehouseData?.alloted} loading={loadingWarehouse} /></div>
          <div className="sub-info">
            {deviceError && <div style={{ color: "#dc2626", fontSize: "12px", marginBottom: "8px" }}>⚠️ {deviceError}</div>}
            <div>
              <span>Unassigned-Stock</span>
              <strong><AnimatedNumber value={Math.max(0, (warehouseData?.instock ?? 0) - (distributorWarehouseData?.instock ?? 0))} loading={loadingWarehouse || loadingDistributorWarehouse} /></strong>
            </div>
          </div>
        </div>
        <div className="overall-card distributor">
          <div className="card-title">Distributor Stock</div>
          <div className="card-number"><AnimatedNumber value={distributorWarehouseData?.alloted} loading={loadingDistributorWarehouse} /></div>
          <div className="sub-info">
            <div><span>Unassigned-Stock</span><strong><AnimatedNumber value={Math.max(0, (distributorWarehouseData?.instock ?? 0) - (lcoWarehouseData?.instock ?? 0))} loading={loadingDistributorWarehouse || loadingLcoWarehouse} /></strong></div>
            <div><span>Total Distributor</span><strong><AnimatedNumber value={userCount?.distributorCount?.lco_count} loading={loadingUserCount} /></strong></div>
          </div>
        </div>
        <div className="overall-card lco">
          <div className="card-title">LCO Stock</div>
          <div className="card-number"><AnimatedNumber value={lcoWarehouseData?.alloted} loading={loadingLcoWarehouse} /></div>
          <div className="sub-info">
            <div><span>Unassigned-Stock</span><strong><AnimatedNumber value={lcoWarehouseData?.instock} loading={loadingLcoWarehouse} /></strong></div>
            <div><span>Total LCO</span><strong><AnimatedNumber value={userCount?.lcoCount?.lco_count} loading={loadingUserCount} /></strong></div>
          </div>
        </div>
        <div className="overall-card active">
          <div className="card-title">Active</div>
          <div className="card-number"><AnimatedNumber value={userStatus?.activeCount} loading={loadingUserStatus} /></div>
          <div className="sub-info">
            <div><span>Total Customer</span><strong><AnimatedNumber value={lcoWarehouseData?.assigned} loading={loadingLcoWarehouse} /></strong></div>
            <div><span>In-Active</span><strong><AnimatedNumber value={userStatus?.inactiveCount} loading={loadingUserStatus} /></strong></div>
          </div>
        </div>
      </div>

      {/* ── Activity Details ─────────────────────────────────────────── */}
      <div className="section-heading"><h2>📅 Activity Details</h2></div>
      {activityError && (
        <div style={{ background: "#fee2e2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", color: "#7f1d1d", fontSize: "14px" }}>
          ⚠️ {activityError}
        </div>
      )}
      <div className="tabs-container">
        <div className="tabs-header">
          {["today", "weekly", "monthly"].map((p) => (
            <button key={p} className={tab === p ? "tab-button active" : "tab-button"} onClick={() => setTab(p)}>
              {p.charAt(0).toUpperCase() + p.slice(1)}
            </button>
          ))}
        </div>
        {["today", "weekly", "monthly"].map((period) =>
          tab === period && (
            <div key={period} className="tab-content active">
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon">📦</div>
                  <div className="stat-label">Stock Moved</div>
                  <div className="stat-value"><AnimatedNumber value={Number(activityData[period]?.alloted)} loading={loadingActivity} /></div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🏪</div>
                  <div className="stat-label">New Distributor Added</div>
                  <div className="stat-value"><AnimatedNumber value={Number(activityData[period]?.distributorCount)} loading={loadingActivity} /></div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">🏢</div>
                  <div className="stat-label">New LCO Added</div>
                  <div className="stat-value"><AnimatedNumber value={Number(activityData[period]?.operatorCount)} loading={loadingActivity} /></div>
                </div>
                <div className="stat-card">
                  <div className="stat-icon">👥</div>
                  <div className="stat-label">New Customer Added</div>
                  <div className="stat-value"><AnimatedNumber value={Number(activityData[period]?.daywise)} loading={loadingActivity} /></div>
                </div>
              </div>
            </div>
          )
        )}
      </div>

    </div>
  );
}